import React, { useState } from 'react';
import PaginationWrap from '../pagination-wrap/index';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import AppLoader from '../AppLoader';

const Table = ({ data, columns, bulkActionEnabled, onRowselected, paginationEnabled, totalPages, totalItems, currentPage, itemsPerPage,
    handleClickPageNumber, handleItemsPerPageChange, handleSearchChange, filters, onSorting, isLoading }) => {
    const [selectedData, setSelectedData] = useState([]);
    const [checkedItems, setCheckedItems] = useState(data ? Array(data.length).fill(false) : []);
    const [unCheckAll, setUnCheckAll] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setSearchTerm(inputValue);
        }, 1000); // Delay of 1 second

        return () => {
            clearTimeout(handler);
        };
    }, [inputValue]);

    React.useEffect(() => {
        clickedPageNumber(1);
        if (handleSearchChange) {
            handleSearchChange(searchTerm);
        }
    }, [searchTerm]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    React.useEffect(() => {
        setUnCheckAll(false);
        setTimeout(() => setUnCheckAll(true), 500)
    }, [data]);
    const onSelectAllClicked = (val) => {
        let selectedValues = [];
        if (val) {
            selectedValues = data.map(e => e);
            setCheckedItems(Array(data.length).fill(true))
        }
        else
            setCheckedItems(Array(data.length).fill(false))

        setSelectedData(selectedValues);
        if (onRowselected)
            onRowselected(selectedValues);
    }
    const clickedPageNumber = (e) => {
        onSelectAllClicked(false);
        handleClickPageNumber(e)
    }
    const handleItemsPerPageChangeInternal = (value) => {
        // Reset the current page to 1 when changing items per page
        if (currentPage !== 1) {
            handleClickPageNumber(1);
        }

        // Call the external handleItemsPerPageChange function
        if (handleItemsPerPageChange) {
            handleItemsPerPageChange(value);
        }
    };

    const onSelectClicked = (val, item, itemIndex) => {
        const updatedCheckedItems = [...checkedItems];
        updatedCheckedItems[itemIndex] = !checkedItems[itemIndex];
        setCheckedItems(updatedCheckedItems);

        const selectedValues = [...selectedData];
        if (!selectedValues.includes(item)) {          //checking weather array contain the id
            selectedValues.push(item);               //adding to array because value doesnt exists
        } else {
            selectedValues.splice(selectedValues.indexOf(item), 1);  //deleting
        }
        setSelectedData(selectedValues);
        onRowselected(selectedValues);
    }
    return (
        <>
            <div className='content-search-box'>
                {
                    paginationEnabled ? <div className='cs-left'>
                        <span>Show</span>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            value={itemsPerPage}
                            onChange={(e) => handleItemsPerPageChangeInternal(parseInt(e.target.value))}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                        <span>Items per page</span>
                    </div> : null
                }
                <div className='cs-right'>
                    {
                        filters ? filters() : null
                    }
                    <input
                        type='search'
                        className='form-control'
                        placeholder='Search...'
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>
                <div className='clear'></div>
            </div>
            <div className='table-responsive-sm'>
                <table className="table">
                    <thead>
                        <TableHeader bulkActionEnabled={bulkActionEnabled} onSelectAllClicked={onSelectAllClicked} columns={columns}
                            unCheckAll={unCheckAll} onSorting={onSorting} />
                    </thead>
                    <tbody>
                        {
                            isLoading ? <tr><td colSpan={columns.length}> <AppLoader /> </td></tr> : <TableRow bulkActionEnabled={bulkActionEnabled} onSelectClicked={onSelectClicked}
                                checkedItems={checkedItems} data={data} columns={columns} />
                        }
                    </tbody>
                </table>
            </div>
            {
                paginationEnabled && data && data.length > 0 ? <PaginationWrap
                    itemPerPage={itemsPerPage}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    handleClickPageNumber={clickedPageNumber}
                    totalItems={totalItems}
                    items={data ? data.length : 0}
                /> : null
            }
        </>
    );
}
export default Table;